<template>
    <div>
      <div class="card-spacing" />
      <form class="flex column card" @submit.prevent="validateAndSubmit">
        <card-header
          :title="$t('cms.register.RegisterTitle')"
          :description="$t('cms.campaign.RegisterDescription')"
          :hasInfoIcon="false"
          :hasCheckMark="false"
        >
          <template #icon>
            <icon register xlarge />
          </template>
        </card-header>

        <input
          type="fullName"
          autocomplete="name"
          v-model="fullName"
          name="fullName"
          :placeholder="$t('cms.register.FullNamePlaceholder')"
          v-validate="'required'"
          class="flex grow box center_text my1"
        >

        <input
          type="password"
          v-model="password"
          name="password"
          autocomplete="new-password"
          :placeholder="$t('cms.register.PasswordPlaceholder')"
          v-validate="'required|min:6'"
          class="flex grow box center_text my1"
        >

        <input
          type="password"
          v-model="repeatPassword"
          name="repeatPassword"
          autocomplete="new-password"
          :placeholder="$t('cms.register.RepeatPasswordPlaceholder')"
          v-validate="'required|min:6'"
          class="flex grow box center_text my1"
        >

        <button
          :disabled="!(
            fullName && !errors.has('fullName') &&
            password && !errors.has('password') &&
            repeatPassword && !errors.has('repeatPassword')
            )"
          style="height: 40px"
          class="flex grow secondary_background white box my1"
        >
          <b>{{ $t('cms.register.RegisterButton') }}</b>
        </button>
      </form>
    </div>
</template>

<script>
import get from 'lodash/get';
import AuthMixin from '../mixins/auth_mixin';
import CardHeader from '@/components/global/CardHeader.vue';

export default {
  name: 'register',

  components: { CardHeader },

  mixins: [AuthMixin],

  data() {
    return {
      fullName: null,
      password: null,
      repeatPassword: null,
    };
  },

  methods: {
    async validateAndSubmit() {
      if (!await this.$validator.validate()) { return; }

      if (this.password !== this.repeatPassword) {
        this.showErrorNotification(this.$t('cms.register.PasswordsDontMatch'));
        return;
      }

      const code = this.$route.params.inviteCode;
      const { fullName, password } = this;
      const acceptInviteInput = { fullName, password, code };

      const mutation = this.$mutations.acceptInvite;
      const { data, errors } = await this.$mutate(mutation, { acceptInviteInput });

      const user = get(data, 'acceptInvite.user');

      if (errors.length > 0 || !user) {
        this.handleErrors(errors);
        this.handleUnauthenticated();
      } else {
        // Call login mixin here to can get access-token and refresh-token
        await this.login(user.email, password);
        this.$router.push({ name: 'dashboard' });
      }
    },
  },
};
</script>
